// PROFILE ENDPOINTS //
// ------------------//

//PROFILE AUTHENTICATION
export const SIGN_UP = `profile/sign-up`;
export const SIGN_OUT = `profile/sign-out`;
export const SIGN_IN = `profile/sign-in`;
//EDIT PROFILE
export const UPDATE_PROFILE = `profile/edit`;
export const UPLOAD_AVATAR = `profile/upload-avatar`;
export const UPLOAD_BANNER = `profile/upload-banner`;
export const UPDATE_USERNAME = `profile/update-username`;

//DELETE PROFILE
export const DELETE_ME = `profile/delete-me`;
// FOLLOW/UNFOLLOW
export const FOLLOW_ID = `profile/follow?id=`;
export const FOLLOW_NAME = `profile/follow?username=`;
export const UNFOLLOW_ID = `profile/unfollow?id=`;
export const UNFOLLOW_NAME = `profile/unfollow?username=`;
// GET PROFILES
export const GET_CURRENT_PROFILE = `profile/current`;
export const GET_ALL_PROFILES = `profile`;
export const GET_PROFILE_USERNAME = `profile?username=`;
export const GET_PROFILE_ID = `profile?id=`;
export const GET_NEW_USERS = `profile/new-users`;
// FORGOT PASSWORD
export const FORGOT_PASSWORD = `profile/forgot-password`;
//PROFILE BOOKMARK
export const ADD_BOOKMARK = `profile/bookmark/add?id=`;
export const REMOVE_BOOKMARK = `profile/bookmark/remove?id=`;
export const GET_BOOKMARK = `profile/bookmarks`;
export const CONFIRM_PROFILE = `profile/confirm`;
export const VERIFY_EMAIL = `profile/verify-email`;
export const MARK_NOTIFICATIONS_READ = `profile/notifications/read`;
// ADMIN ACTIONS
export const DELETE_USER = `profile/delete-user`;
export const SUSPEND_USER = `profile/suspend`;
export const BLOCK_USER = `profile/block`;
export const UNBLOCK_USER = `profile/unblock`;

//  POST ENDPOINTS  //
// ------------------//
export const NEW_POST = `post/new`;
export const REPOST = `post/repost?id=`;

// POST EDIT
// export const EDIT_POST = `${URL}/post/edit?id=`;
export const DELETE_POST = `post/delete?id=`;

//POST LIKE
export const LIKE_POST = `post/like?id=`;
export const UNLIKE_POST = `post/unlike?id=`;

//POST RATE
export const RATE_POST = `post/rate?id=`;
export const POLL_VOTE = `post/poll-vote?id=`;

// POST COMMENT
export const NEW_REPLY = `post/reply/new?id=`;
export const DELETE_COMMENT = `post/reply/delete?id=`;

// GET POSTS
export const GET_ALL_POSTS = `post?page=`;
export const GET_PROFILE_POSTS = `post/profile?username=`;
export const GET_PROFILE_REPLIES = `post/profile-replies?username=`;
export const GET_POST_ID = `post?id=`;
export const GET_FOLLOWING_POSTS = `post/following?page=`;
export const GET_ALL_VIDEOS = `post/videos`;
export const SEARCH_POSTS = `post/search`;

// GET TRENDS
export const GET_TRENDS = `post/trends`;
export const DELETE_TREND = `post/trends?tag=`;

// ADMIN POST ACTIONS
export const PIN_POST = `post/pin?id=`;
export const UNPIN_POST = `post/unpin?id=`;
export const FEATURE_POST = `post/feature?id=`;
export const UNFEATURE_POST = `post/unfeature?id=`;
export const HIDE_POST = `post/hide?id=`;
export const UNHIDE_POST = `post/unhide?id=`;

// HASHTAG
export const CREATE_HASHTAG = `hashtag`;
export const GET_HASHTAG = `hashtag`;

// MESSAGES
export const GET_CONVERSATIONS = `message/conversations`;
export const NEW_MESSAGE = `message`;

// AI ENDPOINTS
export const GENERATE_VIDEO = `ai/generate-video`;
export const REMIX_VIDEO = `ai/remix-video`;
export const LOON_AI_CONVERSATIONS = `loon-ai/conversations`;
export const LOON_AI_CONVERSATION = `loon-ai/conversations/`;
export const LOON_AI_CHAT = `loon-ai/chat`;

// REPORT ENDPOINTS
export const CREATE_REPORT = `report/create`;
export const GET_ALL_REPORTS = `report`;
export const UPDATE_REPORT_STATUS = `report/`;
export const DELETE_REPORT = `report/`;
// SCAMMERS ENDPOINTS
export const GET_ALL_FLAGGED_USERS = `report/flagged-users`;

// CANADA NOW
export const GET_LATEST_NEWS = "api/news/latest-news";
export const GET_ALL_EVENTS = "api/news/all-events";
export const GET_COMMUNITY_EVENTS = "api/events";
export const CREATE_EVENT = "api/events";
export const GET_STOCKS = "market/stocks";
